import { render, staticRenderFns } from "./UserDrills.vue?vue&type=template&id=60de9f30"
import script from "./UserDrills.vue?vue&type=script&lang=js"
export * from "./UserDrills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports